"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var html_definitions_1 = require("./html-definitions");
var ImageViewerComponent = /** @class */ (function () {
    function ImageViewerComponent() {
        this.zoomFactor = 1.0;
        this.mouseDragStartX = 0;
        this.mouseDragStartY = 0;
        this.imageOffsetX = 0;
        this.imageOffsetY = 0;
        this.active = false;
        this.setImageViewerClasses();
        this.view =
            window.rslidy.utils.prependHtmlString(document.body, html_definitions_1.image_viewer);
        this.images = document.getElementsByClassName("rslidy-slide-image");
        this.container = this.view.getElementsByClassName("rslidy-image-viewer-container")[0];
        this.modalImg = this.view.getElementsByClassName("rslidy-image-viewer-content")[0];
        this.addImageOnClickHandlers();
        this.addButtonHandlers();
        this.addMouseEventListeners();
        this.view.style.backgroundColor = window.rslidy.image_viewer_background;
    }
    // ---
    // Description: Closes the image viewer and resets values
    // ---
    ImageViewerComponent.prototype.close = function () {
        this.modalImg.classList.add("rslidy-transition-enabled");
        this.modalImg.style.width = "";
        this.modalImg.style.height = "";
        this.modalImg.style.top = "";
        this.modalImg.style.left = "";
        this.view.style.display = "none";
        this.zoomFactor = 1.0;
        if (this.active) {
            history.replaceState({}, null, "#" + (window.rslidy.content.currentSlideIndex + 1));
            this.active = false;
        }
    };
    // ---
    // Description: Iterate over all slide images and set image viewer classes
    // ---
    ImageViewerComponent.prototype.setImageViewerClasses = function () {
        var slides = document.getElementsByClassName("slide");
        var imgs = new Array();
        for (var _i = 0, slides_1 = slides; _i < slides_1.length; _i++) {
            var slide = slides_1[_i];
            var imgsThisSlide = slide.getElementsByTagName("img");
            for (var _a = 0, imgsThisSlide_1 = imgsThisSlide; _a < imgsThisSlide_1.length; _a++) {
                var img = imgsThisSlide_1[_a];
                imgs.push(img);
            }
        }
        window.rslidy.utils.addElementsClass(imgs, "rslidy-slide-image");
    };
    // ---
    // Description: Add the onclick handler to all slide images
    // ---
    ImageViewerComponent.prototype.addImageOnClickHandlers = function () {
        var _this = this;
        var _loop_1 = function () {
            var image = this_1.images.item(i);
            if (image.classList.contains('disable-image-viewer'))
                return "continue";
            image.ontouchend = function () {
                _this.touch = true;
            };
            image.onclick = function () {
                if (!window.rslidy.image_viewer)
                    return;
                if (_this.touch) {
                    _this.touch = false;
                    return;
                }
                //setup browser back button to close image viewer
                history.pushState(null, null, window.location.href.replace(window.location.hash, "#"));
                _this.view.style.display = "block";
                _this.modalImg.src = image.src;
                var theImage = new Image();
                theImage.src = image.src;
                _this.imageWidth = theImage.width;
                _this.imageHeight = theImage.height;
                // fix for firefox
                if (_this.imageWidth == 0) {
                    _this.imageWidth = _this.modalImg.width;
                }
                if (_this.imageHeight == 0) {
                    _this.imageHeight = _this.modalImg.height;
                }
                _this.containerWidth = _this.container.clientWidth;
                _this.containerHeight = _this.container.clientHeight;
                _this.initialZoom();
                _this.isInsideContainer = true;
                _this.active = true;
            };
            // prevent links around images, they can still be used with
            // right click -> open link in ...
            if (image.parentNode.nodeName.toLowerCase() === 'a') {
                image.parentElement.onclick = function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                };
            }
        };
        var this_1 = this;
        for (var i = 0; i < this.images.length; i++) {
            _loop_1();
        }
    };
    // ---
    // Description: Adds handlers for the image viewer buttons
    // ---
    ImageViewerComponent.prototype.addButtonHandlers = function () {
        var _this = this;
        var spanClose = this.view.getElementsByClassName("rslidy-iv-close")[0];
        spanClose.addEventListener("click", function () {
            _this.close();
        });
        var spanZoomIn = this.view.getElementsByClassName("rslidy-iv-zoom-in")[0];
        spanZoomIn.addEventListener("click", function () {
            _this.zoomIn();
        });
        var spanZoomOut = this.view.getElementsByClassName("rslidy-iv-zoom-out")[0];
        spanZoomOut.addEventListener("click", function () {
            _this.zoomOut();
        });
        var spanZoomReset = document.getElementsByClassName("rslidy-iv-zoom-reset")[0];
        spanZoomReset.addEventListener("click", function () {
            _this.initialZoom();
        });
    };
    // ---
    // Description: Adds support for mouse events
    // ---
    ImageViewerComponent.prototype.addMouseEventListeners = function () {
        var _this = this;
        var mouseDown = false;
        this.container.addEventListener("mouseenter", function (mouseDownEvent) {
            _this.isInsideContainer = true;
        });
        this.container.addEventListener("mouseleave", function (mouseDownEvent) {
            _this.isInsideContainer = false;
        });
        window.addEventListener("resize", function () {
            if (_this.active) {
                _this.containerWidth = _this.container.clientWidth;
                _this.containerHeight = _this.container.clientHeight;
                _this.applyOffset(true);
            }
        });
        this.view.addEventListener("wheel", function (mouseWheelEvent) {
            mouseWheelEvent.preventDefault();
            var delta = Math.max(-1, Math.min(1, mouseWheelEvent.wheelDelta || -mouseWheelEvent.deltaY));
            if (delta > 0) {
                _this.zoomIn();
                var factor = 1 - _this.zoomFactor * 1.2 / _this.zoomFactor;
                _this.imageOffsetX +=
                    (mouseWheelEvent.clientX - window.innerWidth / 2) * factor;
                _this.imageOffsetY +=
                    (mouseWheelEvent.clientY - window.innerHeight / 2) * factor;
                _this.applyOffset(false);
            }
            else if (delta != 0) {
                _this.zoomOut();
                var factor = 1 - _this.zoomFactor / 1.2 / _this.zoomFactor;
                if (_this.zoomFactor / 1.2 > _this.initialZoomFactor / 10) {
                    _this.imageOffsetX +=
                        (mouseWheelEvent.clientX - window.innerWidth / 2) * factor;
                    _this.imageOffsetY +=
                        (mouseWheelEvent.clientY - window.innerHeight / 2) * factor;
                    _this.applyOffset(false);
                }
            }
        }, { passive: true });
        this.view.addEventListener("mousedown", function (mouseDownEvent) {
            mouseDownEvent.preventDefault();
            if (!_this.isInsideContainer) {
                return;
            }
            _this.mouseDragStartX = mouseDownEvent.clientX;
            _this.mouseDragStartY = mouseDownEvent.clientY;
            _this.modalImg.classList.remove("rslidy-transition-enabled");
            mouseDown = true;
        });
        this.view.addEventListener("mousemove", function (mouseMoveEvent) {
            mouseMoveEvent.preventDefault();
            if (!mouseDown) {
                return;
            }
            _this.imageOffsetX =
                _this.imageOffsetX + mouseMoveEvent.clientX - _this.mouseDragStartX;
            _this.imageOffsetY =
                _this.imageOffsetY + mouseMoveEvent.clientY - _this.mouseDragStartY;
            _this.mouseDragStartX = mouseMoveEvent.clientX;
            _this.mouseDragStartY = mouseMoveEvent.clientY;
            _this.applyOffset(false);
        });
        this.view.addEventListener("mouseup", function (mouseUpEvent) {
            mouseDown = false;
        });
    };
    // ---
    // Description: Zoom in on the image
    // ---
    ImageViewerComponent.prototype.zoomIn = function () {
        this.modalImg.classList.add("rslidy-transition-enabled");
        this.zoomFactor *= 1.2;
        this.imageOffsetX =
            this.containerWidth / 2.0 -
                (-this.imageOffsetX + this.containerWidth / 2.0) * 1.2;
        this.imageOffsetY =
            this.containerHeight / 2.0 -
                (-this.imageOffsetY + this.containerHeight / 2.0) * 1.2;
        this.modalImg.style.width = this.imageWidth * this.zoomFactor + "px";
        this.modalImg.style.height = this.imageHeight * this.zoomFactor + "px";
        this.applyOffset(false);
    };
    // ---
    // Description: Zoom out of the image
    // ---
    ImageViewerComponent.prototype.zoomOut = function () {
        this.modalImg.classList.add("rslidy-transition-enabled");
        var zoomBefore = this.zoomFactor;
        this.zoomFactor /= 1.2;
        if (this.zoomFactor < this.initialZoomFactor / 10) {
            this.zoomFactor = this.initialZoomFactor / 10;
        }
        this.imageOffsetX =
            this.containerWidth / 2.0 -
                (-this.imageOffsetX + this.containerWidth / 2.0) /
                    (zoomBefore / this.zoomFactor);
        this.imageOffsetY =
            this.containerHeight / 2.0 -
                (-this.imageOffsetY + this.containerHeight / 2.0) /
                    (zoomBefore / this.zoomFactor);
        this.modalImg.style.width = this.imageWidth * this.zoomFactor + "px";
        this.modalImg.style.height = this.imageHeight * this.zoomFactor + "px";
        this.applyOffset(false);
    };
    // ---
    // Description: Offset the image
    // center: set true to re-center the image, used for initialZoom()
    // ---
    ImageViewerComponent.prototype.applyOffset = function (center) {
        var currentImageWidth = this.imageWidth * this.zoomFactor;
        var currentImageHeight = this.imageHeight * this.zoomFactor;
        if (center) {
            if (currentImageWidth <= this.containerWidth) {
                this.imageOffsetX = (this.containerWidth - currentImageWidth) / 2.0;
            }
            else {
                if (this.containerWidth - this.imageOffsetX >= currentImageWidth) {
                    this.imageOffsetX = this.containerWidth - currentImageWidth;
                }
                else if (this.imageOffsetX > 0) {
                    this.imageOffsetX = 0;
                }
            }
            if (currentImageHeight <= this.containerHeight) {
                this.imageOffsetY = (this.containerHeight - currentImageHeight) / 2.0;
            }
            else {
                if (this.containerHeight - this.imageOffsetY >= currentImageHeight) {
                    this.imageOffsetY = this.containerHeight - currentImageHeight;
                }
                else if (this.imageOffsetY > 0) {
                    this.imageOffsetY = 0;
                }
            }
        }
        this.modalImg.style.left = this.imageOffsetX + "px";
        this.modalImg.style.top = this.imageOffsetY + "px";
    };
    // ---
    // Description: Setup or revert to the initial zoom level
    // ---
    ImageViewerComponent.prototype.initialZoom = function () {
        var aspectImg = this.imageWidth / this.imageHeight;
        var aspectContainer = this.containerWidth / this.containerHeight;
        if (aspectContainer > aspectImg) {
            this.initialZoomFactor = this.containerHeight / this.imageHeight;
            this.imageOffsetX =
                (this.containerWidth - this.imageWidth * this.zoomFactor) / 2.0;
        }
        else {
            this.initialZoomFactor = this.containerWidth / this.imageWidth;
            this.imageOffsetY =
                (this.containerHeight - this.imageHeight * this.zoomFactor) / 2.0;
        }
        this.zoomFactor = this.initialZoomFactor;
        this.modalImg.style.width = this.imageWidth * this.zoomFactor + "px";
        this.modalImg.style.height = this.imageHeight * this.zoomFactor + "px";
        this.applyOffset(true);
    };
    return ImageViewerComponent;
}());
exports.ImageViewerComponent = ImageViewerComponent;
